export enum Vote {
    None = 0,
    Pass = 1,
    Deny = 2,
    MoreInfoNeeded = 3,
    Skipped = 4
}